import * as tasksTypes from './tasksTypes';
import { getTaskProfileById } from 'src/services/tasks.service';

export const getActionRequiredProfileById = taskId => {
  return async dispatch => {
    dispatch(isLoading(tasksTypes.LOADING_TASKS, true));
    await getTaskProfileById(taskId)
      .then(res => {
        if (res) {
          dispatch(getTaskProfileSuccessful(res));
          dispatch(isLoading(tasksTypes.LOADING_TASKS, false));
        } else {
          dispatch(isLoading(tasksTypes.LOADING_TASKS, false));
          throw new Error('failed to query task related profile');
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
};

export const getTaskProfileSuccessful = payload => {
  return {
    type: tasksTypes.GET_TASK_PROFILE_SUCCESS,
    payload,
  };
};

export const setShowProfileIconNameState = payload => ({
  type: tasksTypes.SET_SHOW_PROFILE_ICONNAME_STATE,
  payload,
});

export const isLoading = (type, isLoading) => {
  return {
    type,
    isLoading,
  };
};

export const clearDetails = () => {
  return {
    type: tasksTypes.CLEAR_DETAILS,
  };
};
